// @flow

class ChartAction {
    static DELETED_CHART = "DELETED_CHART";
    static RENAMED_CHART = "RENAMED_CHART";
    static CREATE_CHART_TYPE_CHANGED_ACTION = "CREATE_CHART_TYPE_CHANGED_ACTION";

}

export default ChartAction;